export default __webpack_public_path__ + "static/media/es_ES.596bab47.svg";